import React, { useState, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import Url from 'environment';

const SoccerViewBroadcast = ({
  item,
  style,
  period,
  eventListRef,
  idx,
  finishTime,
  checkExtraTime
}) => {
  const { displayTime, locationType, playText, eventType } = item;
  const [realDateItem, setRealDateItem] = useState(0);
  const [realDateTime, setRealDateTime] = useState(0);

  useEffect(() => {
    if (locationType !== 'TOTAL') {
      const finishTimeCalc =
        finishTime.time + finishTime.extraTime.reduce((a, c) => a + c, 0);
      const time = displayTime.split(':');
      let realTime = +time[0] * 60 + +time[1];

      let calc = (realTime / finishTimeCalc) * 100 - 2;

      // console.log(`${realTime} - ${finishTime} - ${playText} - ${calc}`);

      if (item.period === 1) {
        if (finishTime.extraTime[0] > 0) {
          calc = calc - finishTime.extraTime[0];

          if (calc < 0) {
            calc = 0;
          }
        }

        calc = calc - 3;

        if (calc < 0) {
          calc = 0;
        }
      }

      if (item.period === 2) {
        if (finishTime.extraTime[1] > 0) {
          calc = calc + finishTime.extraTime[1];
        }
      }

      if (item.period === 3) {
        if (calc < 74) {
          calc = 74;
        }

        if (finishTime.extraTime[2] > 0) {
          calc = calc + finishTime.extraTime[2];
        }
      }

      if (checkExtraTime) {
        if (item.period === 2 && calc > 72) {
          if (
            eventType === 'YELLOW_CARD' ||
            eventType === 'RED_CARD' ||
            eventType === 'YELLOW_TO_RED'
          ) {
            calc = 71;
          }
          if (eventType === 'GOAL' || eventType === 'OWN_GOAL') {
            calc = 69;
          }
          if (eventType === 'PK_SUCCESS' || eventType === 'PK_FAIL') {
            calc = 68;
          }
        }
      } else {
        if (
          eventType === 'GOAL' ||
          eventType === 'OWN_GOAL' ||
          eventType === 'PK_SUCCESS' ||
          eventType === 'PK_FAIL'
        ) {
          if (calc > 94) {
            calc = 94;
          }
        } else {
          if (calc > 97) {
            calc = 96.5;
          }
        }

        if (item.period === 2 && calc < 50) {
          calc = 50;
        }
      }

      // console.log(
      //   `period = ${period} - ${item.period} - ${realTime} - ${finishTimeCalc} - ${finishTime.time} - ${finishTime.extraTime} - ${playText} - ${calc}`
      // );

      setRealDateItem(calc);
      setRealDateTime(realTime);
    }
  }, [displayTime, locationType, finishTime, eventType, period, checkExtraTime]);

  const imgSrc = useMemo(() => {
    if (
      eventType === 'GOAL' ||
      eventType === 'OWN_GOAL' ||
      eventType === 'PK_SUCCESS' ||
      eventType === 'PK_FAIL' ||
      eventType === 'YELLOW_CARD' ||
      eventType === 'RED_CARD' ||
      eventType === 'YELLOW_TO_RED'
    ) {
      return `${
        Url.image
      }score_web/football/event/${eventType.toLowerCase()}.png`;
    }
  }, [eventType]);

  if (locationType !== 'TOTAL') {
    if (
      eventType === 'GOAL' ||
      eventType === 'OWN_GOAL' ||
      eventType === 'PK_SUCCESS' ||
      eventType === 'PK_FAIL' ||
      eventType === 'YELLOW_CARD' ||
      eventType === 'RED_CARD' ||
      eventType === 'YELLOW_TO_RED'
    ) {
      let isPlusTwoPixel = false;
      let plusTwoPixel = 2;
      let isOverlay = false;
      let calcLeft = null;
      let childs = eventListRef.current;

      if (!!childs) {
        const prevEl = [...childs.children]
          .filter((item) => {
            const checkLocation =
              item.dataset.location === locationType.toLowerCase();

            if (checkLocation) {
              return item.dataset.id < idx;
            }
          })
          .pop();

        if (!!prevEl) {
          const prevPoistion = Math.round(
            Math.abs(prevEl.style.left.replace('%', ''))
          );
          const curPosition = Math.round(realDateItem);

          calcLeft = curPosition - prevPoistion;

          // console.log(
          //   `${calcLeft} - ${prevEl.dataset.location}-${realDateItem}-${displayTime}-${playText}`
          // );

          if (calcLeft >= 0) {
            if (calcLeft <= 2) {
              isPlusTwoPixel = true;

              if (
                eventType === 'GOAL' ||
                eventType === 'OWN_GOAL' ||
                eventType === 'PK_SUCCESS' ||
                eventType === 'PK_FAIL'
              ) {
                if (realDateItem + 2 > 94) {
                  plusTwoPixel = 1;
                }
              } else {
                if (realDateItem + 2 > 96.5) {
                  plusTwoPixel = 0;
                }
              }
            }

            if (calcLeft <= 4) {
              if (
                eventType !== 'GOAL' &&
                eventType !== 'OWN_GOAL' &&
                eventType !== 'PK_SUCCESS' &&
                eventType !== 'PK_FAIL'
              ) {
                isOverlay = true;
              }
            }
          }
        }
      }

      return (
        <div
          className={clsx(
            style.item,
            style[locationType.toLowerCase()],
            isOverlay && style.shadow
          )}
          style={{
            left: `${realDateItem + (isPlusTwoPixel ? plusTwoPixel : 0)}%`
          }}
          data-id={idx}
          data-location={locationType.toLowerCase()}
        >
          <a>
            <img src={imgSrc} />
          </a>
          <div className={style.inner}>
            <div className={style.layer_event}>
              <div className={style.th}>
                <span className={style.e_info}>상세정보</span>
                <span className={style.e_time}>시간</span>
                <span className={style.e_type}>이벤트</span>
              </div>
              <div className={style.td}>
                <span className={style.e_info}>{playText}</span>
                <span className={style.e_time}>{realDateTime}분</span>
                <span className={style.e_type}>
                  <img src={imgSrc} />
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default SoccerViewBroadcast;
